export default function current_city(state = null, action) {
    switch (action.type) {
        case 'CURRENT_CITY_SET':
            return action.payload
        default:
            return state
    }
} 